// extracted by mini-css-extract-plugin
module.exports = {"notice":"HgjMS","title":"yB4y0","controls":"_7jcvu","block":"_3Ly9z","button":"uu60o","mute":"_8TXQN"};